<template>
  <UnitContext>
    <template #default="{ unitId }">
      <AccountMembersContext
        v-if="unitId"
        :key="`${selectedOrganizationId}-${unitId}`"
        :account-id="unitId"
        :membership-state="['active', 'pending']"
        :subject-type="[
          ACCOUNT_SUBJECT_TYPE.USER,
          ACCOUNT_SUBJECT_TYPE.SERVICE_USER,
        ]"
        :ui-context="'unit'"
      >
        <UnitTabs />
        <RouterView />
      </AccountMembersContext>
    </template>
  </UnitContext>
</template>

<script lang="ts" setup>
import { ACCOUNT_SUBJECT_TYPE } from '@deepcloud/api-deep-admin-backend'
import {
  hasUnitAccess,
  useAccountMembershipsContext,
} from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import AccountMembersContext from '@/components/deepadmin/account/AccountMembersContext.vue'
import UnitContext from '@/components/deepadmin/unit/UnitContext.vue'
import UnitTabs from '@/components/deepadmin/unit/UnitTabs.vue'

const route = useRoute()
const { permissions } = useAuthorizationContext()
const { userGroups, selectedOrganizationId } = useAccountMembershipsContext()

const canAccessUnits = computed(() => {
  const unitId = route.query.unitId as string

  return (
    permissions.canManageGroups ||
    hasUnitAccess(userGroups.value, selectedOrganizationId.value, unitId)
  )
})

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

usePageAccess(computed(() => !canAccessUnits.value))
</script>
